"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
type MarginType = string;
interface BlurFadeProps {
  children: React.ReactNode;
  className?: string;
  variant?: {
    hidden: {
      y: number;
    };
    visible: {
      y: number;
    };
  };
  duration?: number;
  delay?: number;
  yOffset?: number;
  inView?: boolean;
  inViewMargin?: MarginType;
  blur?: string;
}

/**
 * BlurFade — reveal blur+slide+fade. Sebelumnya memakai framer-motion; kini
 * CSS transition + IntersectionObserver agar framer-motion tidak lagi masuk
 * bundle awal setiap rute (PageHeader/dashboard-chrome dipakai ~55 rute).
 * Perilaku & tampilan dipertahankan: initial hidden → visible; jika `inView`
 * animasi menunggu elemen masuk viewport (once), rootMargin = inViewMargin.
 */
export function BlurFade(t0) {
  const $ = _c(13);
  const {
    children,
    className,
    variant,
    duration: t1,
    delay: t2,
    yOffset: t3,
    inView: t4,
    inViewMargin: t5,
    blur: t6
  } = t0;
  const duration = t1 === undefined ? 0.4 : t1;
  const delay = t2 === undefined ? 0 : t2;
  const yOffset = t3 === undefined ? 6 : t3;
  const inView = t4 === undefined ? false : t4;
  const inViewMargin = t5 === undefined ? "-50px" : t5;
  const blur = t6 === undefined ? "6px" : t6;
  const ref = useRef(null);
  const [shown, setShown] = useState(false);
  const hiddenY = variant ? variant.hidden.y : yOffset;
  const visibleY = variant ? variant.visible.y : -yOffset;
  let t7;
  let t8;
  if ($[0] !== inView || $[1] !== inViewMargin) {
    t7 = () => {
      if (!inView) {
        const raf = requestAnimationFrame(() => setShown(true));
        return () => cancelAnimationFrame(raf);
      }
      const el = ref.current;
      if (!el) {
        return;
      }
      const observer = new IntersectionObserver(entries => {
        if (entries[0]?.isIntersecting) {
          setShown(true);
          observer.disconnect();
        }
      }, {
        rootMargin: inViewMargin
      });
      observer.observe(el);
      return () => observer.disconnect();
    };
    t8 = [inView, inViewMargin];
    $[0] = inView;
    $[1] = inViewMargin;
    $[2] = t7;
    $[3] = t8;
  } else {
    t7 = $[2];
    t8 = $[3];
  }
  useEffect(t7, t8);
  const t9 = shown ? 1 : 0;
  const t10 = `translateY(${shown ? visibleY : hiddenY}px)`;
  const t11 = shown ? "blur(0px)" : `blur(${blur})`;
  const t12 = `opacity ${duration}s ease-out ${0.04 + delay}s, transform ${duration}s ease-out ${0.04 + delay}s, filter ${duration}s ease-out ${0.04 + delay}s`;
  let t13;
  if ($[4] !== t10 || $[5] !== t11 || $[6] !== t12 || $[7] !== t9) {
    t13 = {
      opacity: t9,
      transform: t10,
      filter: t11,
      transition: t12,
      willChange: "opacity, transform, filter"
    };
    $[4] = t10;
    $[5] = t11;
    $[6] = t12;
    $[7] = t9;
    $[8] = t13;
  } else {
    t13 = $[8];
  }
  const style = t13;
  let t14;
  if ($[9] !== children || $[10] !== className || $[11] !== style) {
    t14 = <div ref={ref} className={className} style={style}>{children}</div>;
    $[9] = children;
    $[10] = className;
    $[11] = style;
    $[12] = t14;
  } else {
    t14 = $[12];
  }
  return t14;
}